
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/my-events",
      function () {
        return require("private-next-pages/dashboard/my-events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/my-events"])
      });
    }
  